const REACTIVATE_TODAY = '/reactivate-today';
const REACTIVATE_MEMBERSHIP = '/reactivate-my-membership';
const REACTIVATE_THANKS = '/reactivate-thanks';
const UPGRADE_CONFIRMATION = '/upgrade-confirmation';
const ACTIVATE_BOX_SUBSCRIPTION = '/activate-box-subscription';
const UPGRADE_THANKS = '/upgrade-thanks';
const ACTIVATE_MEMBERSHIP = '/activate-membership';
const TRIAL_UPGRADE_THANKS = '/trial-upgrade-thanks';
const EMAIL_PREFERENCES = '/manage-email-preferences';
const SUBSCRIBE_TODAY_THANKS = '/subscribe-today-thanks';
const ORDER_TRACKING = '/orders/track-shipment';
const MY_ACCOUNT = '/my-account';
const LOCK_IN_RATE_PATH = '/lock-in-rate';
const CONTACT_US_PATH = '/contact-us';
const PRORATE_UPGRADE = '/prorated-upgrade';

export {
  LOCK_IN_RATE_PATH,
  CONTACT_US_PATH,
  PRORATE_UPGRADE,
  REACTIVATE_TODAY,
  REACTIVATE_MEMBERSHIP,
  REACTIVATE_THANKS,
  UPGRADE_CONFIRMATION,
  ACTIVATE_BOX_SUBSCRIPTION,
  UPGRADE_THANKS,
  ACTIVATE_MEMBERSHIP,
  TRIAL_UPGRADE_THANKS,
  EMAIL_PREFERENCES,
  SUBSCRIBE_TODAY_THANKS,
  MY_ACCOUNT,
  ORDER_TRACKING,
};
